import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { makeSessionJsonStorage, withPrefix } from "./storage";

export type ActiveSelection =
  | { kind: "stop"; id: string } 
  | { kind: "line"; id: string }  
  | null;

export const activeSelectionAtom = atomWithStorage<ActiveSelection>(
  withPrefix("active-selection"),
  null,
  makeSessionJsonStorage<ActiveSelection>()
);

export const activeStopIdDerivedAtom = atom((get) => {
  const a = get(activeSelectionAtom);
  return a?.kind === "stop" ? a.id : null;
});

export const activeLineIdDerivedAtom = atom((get) => {
  const a = get(activeSelectionAtom);
  return a?.kind === "line" ? a.id : null;
});
